<template>
  <div class="border">
    <Form :label-width="100" :model="formData" :rules="formRules" ref="form">

      <FormItem label="租期方式" prop="conType">
        <Select v-model="formData.conType" style="width: 150px" @on-change="changeType">
          <Option value="">请选择</Option>
          <Option v-for="(item,index) in leaseTime" :value="item.value" :key="'keyA'+index">{{item.text}}</Option>
        </Select>
      </FormItem>

      <FormItem label="租期时间" prop="conEndDate">
        <DatePicker placeholder="起租日" v-model="formData.conStartDate" @on-change="setreservationSignDate"
                    :options="option0"></DatePicker>
        -
        <DatePicker v-if="formData.conType===1" placeholder="到期日" v-model="formData.conEndDate"
                    :options="option1"></DatePicker>
        <DatePicker v-if="formData.conType===2" v-model="formData.conEndDate" :options="option2"
                    :start-date="option2.minTime"></DatePicker>
        <DatePicker v-if="formData.conType===0" v-model="formData.conEndDate" disabled></DatePicker>
        <DatePicker v-if="formData.conType===''" disabled></DatePicker>
        <span class="ivu-btn" v-if="year">{{year}}年</span>
        <span class="ivu-btn" v-if="monthAndDay.month">{{monthAndDay.month}}月</span>
        <span class="ivu-btn" v-if="monthAndDay.day">{{monthAndDay.day}}天</span>
      </FormItem>

      <FormItem label="预计签约日期" prop="reservationSignDate">
        <DatePicker class="width3" disabled v-model="formData.reservationSignDate" type="date"
                    placeholder=""></DatePicker>
      </FormItem>

      <FormItem label="收取定金" prop="depositAccount">
        <Input class="width3" v-model="formData.depositAccount" @on-blur="calculation"></Input>
        <span>元</span>
      </FormItem>
      <FormItem label="预订房租" prop="houseRentPrice">
        <Input class="width3" disabled v-model="formData.houseRentPrice"></Input>
        <span>元/月</span>
        <span class="error-color">（实际租金基于付款方式会有上下浮动）</span>
      </FormItem>

    </Form>
  </div>
</template>
<script>

  //组件 from  个人签约邀请

  import {getSignInviteInfo, saveSignInviteInfo, validSignInvite} from "api/contractList";
  // import {formatDateTime} from "../../utils/format";
  import {formatDateTime} from "../../../../../utils/format";

  export default {
    components: {},
    props: {
      data: {
        type: Object,
        default: null
      }

    },
    computed: {
      option0(){
        if(!this.responseDate){
          return {}
        }
        let data=this.responseDate
        return {
          disabledDate(date) {
            return date && date.valueOf() < data.minReservationSignDate-86399999 || date.valueOf() > data.maxReservationSignDate;
          }

        }

      },

      monthAndDay() {
        let ret = {
          month: '',
          day: ''
        }
        if (!this.formData.conStartDate || !this.formData.conEndDate || (this.formData.conType === 1)) {
          return ret
        }
        let year1 = this.formData.conStartDate.getFullYear()
        let month1 = this.formData.conStartDate.getMonth()
        let day1 = this.formData.conStartDate.getDate()
        console.log('------')
        console.log(day1)
        let year2 = this.formData.conEndDate.getFullYear()
        let month2 = this.formData.conEndDate.getMonth()
        let day2 = this.formData.conEndDate.getDate()
        let lasttmonthdays = new Date(year2, month2, 0).getDate()

        let diffM = month2 - month1
        let diffD = day2 - day1

        if (year1 == year2) {
          if (diffD >= 0) {
            ret.day = diffD + 1
            ret.month = month2 - month1
          } else if (diffD == -1) {
            ret.day = 0
            ret.month = diffM
          } else {
            ret.day = diffD + lasttmonthdays + 1
            ret.month = diffM - 1
          }
        } else {
          if (diffD >= 0) {
            ret.day = diffD + 1
            ret.month = diffM + 12
          } else if (diffD == -1) {
            ret.day = 0
            ret.month = diffM + 12

          } else {
            ret.day = diffD + lasttmonthdays + 1

            ret.month = diffM + 12 - 1
          }
        }
        return ret
      },
      option2() {

        if (!this.formData.conStartDate || !this.rentTermMonthStart || !this.rentTermMonthEnd) {
          return {}
        }
        let min = this.rentTermMonthStart
        let max = this.rentTermMonthEnd

        let minTime = this.formData.conStartDate.valueOf() + 3600 * 24 * 1000 * (min - 1)
        let maxTime = this.formData.conStartDate.valueOf() + 3600 * 24 * 1000 * (max - 1)
        minTime = minTime > this.stockMaxSignDate ? this.stockMaxSignDate : minTime
        maxTime = maxTime > this.stockMaxSignDate ? this.stockMaxSignDate : maxTime

        return {
          disabledDate(date) {
            return date && date.valueOf() < minTime || date.valueOf() > maxTime;
          },
          minTime: new Date(minTime)
        }
      },
      option1() {
        if (!this.formData.conStartDate || !this.rentTermYearStart || !this.rentTermYearEnd) {
          return {}
        }
        let shortcuts = []
        let year = this.formData.conStartDate.getFullYear()
        let month = this.formData.conStartDate.getMonth()
        let date = this.formData.conStartDate.getDate()
        for (let i = this.rentTermYearStart; i <= this.rentTermYearEnd; i++) {
          let num1 = (new Date(year + i, month, date - 1)).valueOf()
          if (num1 > Number(this.stockMaxSignDate)) {
            break;
          }
          shortcuts.push({
            text: i + '年',
            value() {
              return (year + i) + '-' + (month + 1) + '-' + (date - 1)
            },
            onClick: () => {
              this.year = i
            }
          })
        }
        return {
          shortcuts: shortcuts,
          disabledDate() {
            return true
          }
        }
      }

    },
    data() {
      return {
        formData: {
          conType: '',
          conEndDate: '',
          reservationSignDate: '',
          depositAccount: '',
          houseRentPrice: '',
          conStartDate:''

        },
        formRules: {
          conType: [{required: true, type: 'number', message: ' ', trigger: 'change'}],
          conEndDate: [{required: true, message: ' ', trigger: 'change', type: 'object'}],
          conStartDate: [{required: true, message: ' ', trigger: 'change', type: 'object'}],

          reservationSignDate: [{required: true, message: ' ', trigger: 'change', type: 'object'}],
          depositAccount: [{required: true, trigger: 'blur', message: ' ', validator: this.validateNumber2}],
          houseRentPrice: [{required: true, trigger: 'blur', message: ' ', validator: this.validateNumber2}]
        },
        responseDate: null,
        year: '',
        projectName: '',
        // phone: '',
        leaseTime: [],//[{text:'年租',value:1},{text:'月租',value:2},{text:'尾房',value:0}],
        signInviteList: [],
        rentTermYearStart: '',
        rentTermYearEnd: '',
        rentTermMonthStart: '',
        rentTermMonthEnd: '',
        stockMaxSignDate: '',
        // conEndDate: ''
      }
    },
    methods: {
      setDate(value,num) {
        let date = new Date(value);
        // if (date) {
          let year = date.getFullYear() + num
          let month = date.getMonth()
          let day = date.getDate() - 1
          return new Date(year, month, day)
        // }
      },
      setreservationSignDate(value){
        this.year=0
        this.formData.reservationSignDate=value

        if (this.formData.conType === 0 ) {
          return
        }
        if (!value) {
          this.formData.conEndDate=''
          return

        }
        if (this.formData.conType === 2) {

          let data = new Date(value).valueOf() + 3600 * 24 * 1000 * (this.rentTermMonthStart - 1)
          this.formData.conEndDate = new Date(data)

        }
        if (this.formData.conType === 1) {
          this.year = this.rentTermYearStart
          this.formData.conEndDate = this.setDate(value,this.rentTermYearStart)



        }
        // if(this.formData.conType!==0){
        //   this.formData.conEndDate=''
        // }

      },
      validate() {
        let re = null
        this.$refs['form'].validate(bool => {
          re = bool
        })
        return re
      },
      validateNumber2(rule, value, callback) {
        let pattern = /^(\d+)(\.\d+)?$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      init() {
        this.cleanData()
        this.getSignInviteInfo()

      },
      format(data) {
        if (!data) {
          return ''
        }
        return formatDateTime(data, false)

      },
      calculation(){
        let pattern = /^(\d+)(\.\d+)?$/
        if (!pattern.test(this.formData.depositAccount)) {
          this.$Message.error('请输入正确的定金金额')
          this.formData.depositAccount = 0
        }
        if(this.formData.depositAccount.length > 5){
          this.$Message.error('预订金金额不能超过5位')
          this.formData.depositAccount = 0
        }
        this.formData.depositAccount = parseInt(this.formData.depositAccount)
      },
      cleanData() {
        // this.conType = ''
        // this.conEndDate = ''
        this.formData = {
          conType: '',
          conEndDate: '',
          reservationSignDate: '',
          depositAccount: '',
          houseRentPrice: '',
          conStartDate:''
        }

        this.leaseTime = []
        this.signInviteList = []

        this.rentTermYearStart = ''
        this.rentTermYearEnd = ''
        this.rentTermMonthStart = ''
        this.rentTermMonthEnd = ''
        this.stockMaxSignDate = ''
        this.responseDate = null

        this.$refs['form'].resetFields()
      },
      changeType(value) {
        if (value === 0) {
          this.formData.conEndDate = this.stockMaxSignDate
        } else {
          this.formData.conEndDate = ''
        }
        this.year = ''
      },
      getSignInviteInfo() {
        if (!this.data) {
          return
        }

        let params = {
          stockFid: this.data.stockFid,
        }
        getSignInviteInfo(params).then(res => {
          if (!res.data) {
            return
          }
          let data = res.data
          this.$emit('projectName', {projectName: data.projectName, projectFid: data.projectFid})
          // this.projectName = data.projectName
          // this.phone = data.phone
          this.leaseTime = data.leaseTime
          data.signInviteList && (this.signInviteList = data.signInviteList)
          this.rentTermYearStart = data.rentTermYearStart
          this.rentTermYearEnd = data.rentTermYearEnd
          this.rentTermMonthStart = data.rentTermMonthStart
          this.rentTermMonthEnd = data.rentTermMonthEnd
          this.stockMaxSignDate = new Date(data.stockMaxSignDate)
          // this.leaseTime.length > 0 && (this.conType = this.leaseTime[0].value)
          this.responseDate = res.data


          // this.formData.reservationSignDate = new Date(data.conStartDate)
          this.formData.depositAccount = data.stockRentDeposit
          this.formData.houseRentPrice = data.stockRentPrice
        }).catch(error => {
          this.isShow = false
        })
      },
    }

  }
</script>

<style scoped>
  .left, .right {
    display: inline-block;
    line-height: 2.5;
  }

  .left {
    width: 100px;
    /*text-align: right;*/
    margin-left: 20px;
  }

  .inputwidth {
    width: 200px;
  }

  .width3 {
    width: 200px !important;
    display: inline-block;
  }

  .border {
    border-top: 1px solid #DDDEE1;
    padding-top: 20px;
  }

</style>
